import styles from './footer.module.scss';

const Footer = () => {
  return (
    <div className={styles.container}>
      <p>Copyright ⓒ 2023. ChohyePark All rights reserved</p>
    </div>
  );
};

export default Footer;
